import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import JsonLd from "components/JsonLd"
import LandingPage from "pages/LandingPage"
import ProjectsPage from "pages/ProjectsPage"
import ProjectPage from "pages/ProjectPage"
import TokenPage from "pages/TokenPage"
import UserPage from "pages/UserPage"
import AboutPage from "pages/AboutPage"
import Providers from "components/Providers"
import CompositeMinterPage from "pages/CompositeMinterPage"
import FeaturedTokenPage from "pages/FeaturedTokenPage"
import MediaPage from "pages/MediaPage"
import MediaDetailPage from "pages/MediaDetailPage"
import TermsPage from "pages/TermsPage"
import PrivacyPage from "pages/PrivacyPage"

function App() {
  return (
    <Providers>
      <JsonLd />
      <Router>
        <Routes>
          <Route index element={<AboutPage/>}/>
          <Route path="dots" element={<LandingPage projectKey="dots"/>}/>
          <Route path="dots/:tokenId" element={<FeaturedTokenPage projectKey="dots"/>}/>
          <Route path="dots-composites" element={<LandingPage projectKey="dots-composites"/>}/>
          <Route path="dots-composites/:tokenId" element={<FeaturedTokenPage projectKey="dots-composites"/>}/>
          <Route path="landing" element={<LandingPage projectKey="dots"/>}/>
          <Route path="projects" element={<ProjectsPage/>}/>
          <Route path="media" element={<MediaPage/>}/>
          <Route path="media/:slug" element={<MediaDetailPage/>}/>
          <Route path="terms" element={<TermsPage/>}/>
          <Route path="privacy" element={<PrivacyPage/>}/>
          <Route path="project/:contractAddress/:projectId" element={<ProjectPage/>}/>
          <Route path="builder" element={<CompositeMinterPage/>}/>
          <Route path="token/:contractAddress/:id" element={<TokenPage/>}/>
          <Route path="user/:walletAddress" element={<UserPage/>}/>
        </Routes>
      </Router>
      <ToastContainer
        autoClose={10000}
        position="bottom-right"
        theme="dark"
        newestOnTop
        pauseOnHover
        pauseOnFocusLoss
      />
    </Providers>
  )
}

export default App
